import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { formatApiError } from "@/lib/api";
import { toast } from "sonner";

export default function Register() {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [club, setClub] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState("");
  const { register } = useAuth();
  const nav = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    setLoading(true);
    try {
      await register({ name, email, club, password });
      toast.success("Willkommen im FMP!");
      nav("/dashboard");
    } catch (e) {
      setErr(formatApiError(e));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-[80vh] flex items-center justify-center px-6 py-16">
      <div className="w-full max-w-md">
        <div className="font-display text-xs tracking-[0.3em] text-[#CCFF00] mb-3">
          / TRAINER-REGISTRIERUNG
        </div>
        <h1 className="font-heading font-black text-4xl leading-tight tracking-tight mb-8">
          Kostenloses Konto anlegen.
        </h1>
        <form onSubmit={submit} className="space-y-4" data-testid="register-form">
          <div>
            <label className="font-display text-xs tracking-widest text-white/60 block mb-2">
              Name
            </label>
            <input
              data-testid="register-name"
              required
              value={name}
              onChange={(e) => setName(e.target.value)}
              className="w-full bg-[#111214] border border-white/10 rounded-md px-4 py-3 text-white focus:border-[#CCFF00] outline-none"
            />
          </div>
          <div>
            <label className="font-display text-xs tracking-widest text-white/60 block mb-2">
              Verein (optional)
            </label>
            <input
              data-testid="register-club"
              value={club}
              onChange={(e) => setClub(e.target.value)}
              className="w-full bg-[#111214] border border-white/10 rounded-md px-4 py-3 text-white focus:border-[#CCFF00] outline-none"
            />
          </div>
          <div>
            <label className="font-display text-xs tracking-widest text-white/60 block mb-2">
              E-Mail
            </label>
            <input
              data-testid="register-email"
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full bg-[#111214] border border-white/10 rounded-md px-4 py-3 text-white focus:border-[#CCFF00] outline-none"
            />
          </div>
          <div>
            <label className="font-display text-xs tracking-widest text-white/60 block mb-2">
              Passwort (min. 6 Zeichen)
            </label>
            <input
              data-testid="register-password"
              type="password"
              required
              minLength={6}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full bg-[#111214] border border-white/10 rounded-md px-4 py-3 text-white focus:border-[#CCFF00] outline-none"
            />
          </div>
          {err && (
            <div data-testid="register-error" className="text-sm text-red-400">
              {err}
            </div>
          )}
          <button
            data-testid="register-submit"
            disabled={loading}
            className="btn-primary w-full justify-center"
          >
            {loading ? "Konto wird angelegt …" : "Konto anlegen"}
          </button>
        </form>
        <div className="mt-6 text-sm text-white/60 text-center">
          Schon registriert?{" "}
          <Link to="/login" data-testid="register-goto-login" className="text-[#CCFF00] hover:underline font-semibold">
            Zum Login
          </Link>
        </div>
      </div>
    </div>
  );
}
